/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ARTICLE SENTIMENT V2 CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  generalsection: {
    '& .sectiongroupv2 > .header': {
      width: '100%'
    },
    '& .previewconfig': {
      maxWidth: '500px'
    }
  }
});
